export default __webpack_public_path__ + "static/media/atb-financial-logo.5f821d74.svg";